import { useEffect, useState } from "react";

const Open = ({ active }) => {
  const [primaryColor, setPrimaryColor] = useState(
    active
      ? "#fff"
      : getComputedStyle(document.documentElement)
          .getPropertyValue("--theme")
          ?.trim()
  );
  useEffect(() => {
    setPrimaryColor(
      active
        ? "#fff"
        : getComputedStyle(document.documentElement)
            .getPropertyValue("--theme")
            ?.trim()
    );
  }, [active]);
  return (
    <svg
      fill={primaryColor}
      className="size-5"
      viewBox="0 0 36.00 36.00"
      version="1.1"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      stroke-width="0.25200000000000006"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0" />

      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <g id="SVGRepo_iconCarrier">
        {" "}
        <title>assign-user-line</title>{" "}
        <path
          d="M18,17a7.46,7.46,0,1,0-7.45-7.46A7.46,7.46,0,0,0,18,17ZM18,4.07a5.46,5.46,0,1,1-5.45,5.45A5.46,5.46,0,0,1,18,4.07Z"
          class="clr-i-outline clr-i-outline-path-1"
        />
        <path
          d="M6,31.89V25.77a16.13,16.13,0,0,1,12-5,16.61,16.61,0,0,1,8.71,2.33l1.35-1.51A18.53,18.53,0,0,0,18,18.74,17.7,17.7,0,0,0,4.21,24.8a1,1,0,0,0-.21.6v6.49A2.06,2.06,0,0,0,6,34H18.39l-1.9-2Z"
          class="clr-i-outline clr-i-outline-path-2"
        />
        <path
          d="M30,31.89,30,32H26.85l-1.8,2H30a2.06,2.06,0,0,0,2-2.07V26.2l-2,2.23Z"
          class="clr-i-outline clr-i-outline-path-3"
        />
        <path
          d="M34.76,18.62a1,1,0,0,0-1.41.08l-11.62,13-5.2-5.59A1,1,0,0,0,15.12,26a1,1,0,0,0-.06,1.42l6.69,7.2L34.84,20A1,1,0,0,0,34.76,18.62Z"
          class="clr-i-outline clr-i-outline-path-4"
        />{" "}
        <rect x="0" y="0" width="36" height="36" fill-opacity="0" />{" "}
      </g>
    </svg>
  );
};
export default Open;
